import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { push } from 'react-router-redux';
import DocumentMeta from 'react-document-meta';


export default class FestivalVolunteer extends Component {
  constructor(props) {
    super(props);
  }


  componentDidMount() {
    if (typeof(window) !== "undefined") {
      window.scrollTo(0,0)
    }
  }


  render() {

    let browser = this.props.browser;


    return(
      <div>

        <div className="festivalHome-bannerWrapper">

          <Link to="/girls-festival/tickets"><img className="desktop" src="/images/festival/home/gf_banner_desktop4.jpg" /></Link>

          <Link to="/girls-festival/tickets"><img className="mobile" src="/images/festival/home/gf_banner_mobile_no_btn.jpg" /></Link>
        </div>

        <div className="content-wrapper">
          <div className="headerTagWrapper">
            <h1 className="page-heading">Welcome to the WorldWideWomen Girls' Festival volunteer page!</h1>


            <p className="festivalVolunteer-pTag">Imagine being part of a day of exploration, discovery, and connection designed for girls of all ages. The 3rd annual WorldWideWomen Girls' Festival on Saturday, October 6th is the buzz of the Bay Area! We are anticipating at least 4,000 attendees, and <Link to="/girls-festival/program">this year's program</Link> promises to be amazing. We would absolutely love your support in volunteering at the event. Join us and help girls feel empowered, educated, inspired, and, most-importantly, confident in who they are!</p>

            <p className="festivalVolunteer-pTag">Select a shift below to sign up as a volunteer. Please note: if you experience trouble registering, please email <a href="mailto:mstone@worldwidewomen.co">Michelle Stone</a>.</p>



          </div>



          <div className="festivalVolunteer-iframeWrapper">
            <iframe id="fc-embed-frame" src="https://www.flipcause.com/widget/Mzc2NjU=" scrolling="no"></iframe>
          </div>





        </div>



      </div>
    )
  }
};



// WEBPACK FOOTER //
// ./src/containers/FestivalVolunteer.jsx